import { render, staticRenderFns } from "./sceneryRosiPicture.vue?vue&type=template&id=22544da4&scoped=true&"
import script from "./sceneryRosiPicture.vue?vue&type=script&lang=js&"
export * from "./sceneryRosiPicture.vue?vue&type=script&lang=js&"
import style0 from "./sceneryRosiPicture.vue?vue&type=style&index=0&id=22544da4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22544da4",
  null
  
)

component.options.__file = "sceneryRosiPicture.vue"
export default component.exports